import { A, fetchUpdateEmailEditableTemplate } from '../actions/settings';
import update from 'immutability-helper';

const initialState = {
  getCounteragents: {
    isFetching: false,
    error: null,
  },
  getCheckoutSettings: {
    isFetching: false,
    error: null,
  },
  getOrganizationSettings: {
    isFetching: false,
    error: null,
  },
  updateOrganizationSettings: {
    isFetching: false,
    error: null,
  },
  getDomainAliasSettings: {
    isFetching: false,
    error: null,
  },
  updateDomainAliasSettings: {
    isFetching: false,
    error: null,
  },
  getPaymentMethods: {
    isFetching: false,
    error: null,
  },
  updateCheckoutSettings: {
    isFetching: false,
    error: null,
  },
  updateDeliveryInfoListSettings: {
    isFetching: false,
    error: null,
  },
  updatePaymentMethodSettings: {
    isFetching: false,
    error: null,
  },
  updateAcquaringSettings: {
    isFetching: false,
    error: null,
  },
  deletePaymentMethodSettings: {
    isFetching: false,
    error: null,
  },
  getEmailEditableTemplate: {
    isFetching: false,
    error: null,
  },
  updateEmailEditableTemplate: {
    isFetching: false,
    error: null,
  },
  getEmailServerSettings: {
    isFetching: false,
    error: null,
  },
  updateEmailServerSettings: {
    isFetching: false,
    error: null,
  },
  getCountriesList: {
    isFetching: false,
    error: null,
  },
  updateCounteragents: {
    isFetching: false,
    error: null,
  },
  deleteounteragent: {
    isFetching: false,
    error: null,
  },
  getPromocodes: {
    isFetching: false,
    error: null,
  },
  savePromocode: {
    isFetching: false,
    error: null,
  },
  deletePromocode: {
    isFetching: false,
    error: null,
  },

  getFeedSettings: {
    isFetching: false,
    error: null,
  },
  deleteFeedSettings: {
    isFetching: false,
    error: null,
  },
  updateFeedSettings: {
    isFetching: false,
    error: null,
  },
  refreshFeed: {
    isFetching: false,
    error: null,
  },
  getPriceSettings: {
    isFetching: false,
    error: null,
  },
  updatePriceSettings: {
    isFetching: false,
    error: null,
  },
  getUsers: {
    isFetching: false,
    error: null,
  },
  updateUser: {
    isFetching: false,
    error: null,
  },
  deleteUser: {
    isFetching: false,
    error: null,
  },
  getUserRoles: {
    isFetching: false,
    error: null,
  },
  updateUserRole: {
    isFetching: false,
    error: null,
  },
  deleteUserRole: {
    isFetching: false,
    error: null,
  },
  getPaymentSettings: {
    isFetching: false,
    error: null,
  },
  getNotifications: {
    isFetching: false,
    error: null,
  },
  getNotificationTypes: {
    isFetching: false,
    error: null,
  },
  updateNotification: {
    isFetching: false,
    error: null,
  },
  deleteNotification: {
    isFetching: false,
    error: null,
  },
  getAdAttachments: {
    isFetching: false,
    error: null,
  },
  deleteAdAttachments: {
    isFetching: false,
    error: null,
  },
  getProviders: {
    isFetching: false,
    error: null,
  },
  getEshopsInfo: {
    isFetching: false,
    error: null,
  },
  checkoutSettings: {},
  organizationSettings: {},
  countries: [],
  emailSettings: {},
  priceSettings: {},
  paymentSettings: {},
  adAttachments: [],
  providers: [],
  eShops: [],
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_GET_COUNTERAGENTS:
      return update(state, {
        getCounteragents: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_COUNTERAGENTS:
      return update(state, {
        getCounteragents: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_COUNTERAGENTS:
      return update(state, {
        getCounteragents: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_CHECKOUT_SETTINGS:
      return update(state, {
        getCheckoutSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_CHECKOUT_SETTINGS:
      return update(state, {
        getCheckoutSettings: {
          isFetching: { $set: false },
        },
        checkoutSettings: { $set: action.data },
      });

    case A.ERROR_GET_CHECKOUT_SETTINGS:
      return update(state, {
        getCheckoutSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORGANIZATION_SETTINGS:
      return update(state, {
        getOrganizationSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORGANIZATION_SETTINGS:
      return update(state, {
        getOrganizationSettings: {
          isFetching: { $set: false },
        },
        organizationSettings: { $set: action.data },
      });

    case A.ERROR_GET_ORGANIZATION_SETTINGS:
      return update(state, {
        getOrganizationSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORGANIZATION_SETTINGS:
      return update(state, {
        updateOrganizationSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORGANIZATION_SETTINGS:
      return update(state, {
        updateOrganizationSettings: {
          isFetching: { $set: false },
        },
        // organizationSettings:{$set:action.data}
      });

    case A.ERROR_UPDATE_ORGANIZATION_SETTINGS:
      return update(state, {
        updateOrganizationSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_DOMAIN_ALIAS_SETTINGS:
      return update(state, {
        getDomainAliasSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_DOMAIN_ALIAS_SETTINGS:
      return update(state, {
        getDomainAliasSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_DOMAIN_ALIAS_SETTINGS:
      return update(state, {
        getDomainAliasSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_DOMAIN_ALIAS_SETTINGS:
      return update(state, {
        updateDomainAliasSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_DOMAIN_ALIAS_SETTINGS:
      return update(state, {
        updateDomainAliasSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_DOMAIN_ALIAS_SETTINGS:
      return update(state, {
        updateDomainAliasSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PAYMENT_METHODS:
      return update(state, {
        getPaymentMethods: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PAYMENT_METHODS:
      return update(state, {
        getPaymentMethods: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_PAYMENT_METHODS:
      return update(state, {
        getPaymentMethods: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_CHECKOUT_SETTINGS:
      return update(state, {
        updateCheckoutSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_CHECKOUT_SETTINGS:
      return update(state, {
        updateCheckoutSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_CHECKOUT_SETTINGS:
      return update(state, {
        updateCheckoutSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_DELIVERY_INFO_LIST_SETTINGS:
      return update(state, {
        updateDeliveryInfoListSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_DELIVERY_INFO_LIST_SETTINGS:
      return update(state, {
        updateDeliveryInfoListSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_DELIVERY_INFO_LIST_SETTINGS:
      return update(state, {
        updateDeliveryInfoListSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PAYMENT_METHOD_SETTINGS:
      return update(state, {
        updatePaymentMethodSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PAYMENT_METHOD_SETTINGS:
      return update(state, {
        updatePaymentMethodSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PAYMENT_METHOD_SETTINGS:
      return update(state, {
        updatePaymentMethodSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ACQUARING_SETTINGS:
      return update(state, {
        updateAcquaringSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ACQUARING_SETTINGS:
      return update(state, {
        updateAcquaringSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ACQUARING_SETTINGS:
      return update(state, {
        updateAcquaringSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_PAYMENT_METHOD_SETTINGS:
      return update(state, {
        deletePaymentMethodSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_PAYMENT_METHOD_SETTINGS:
      return update(state, {
        deletePaymentMethodSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_PAYMENT_METHOD_SETTINGS:
      return update(state, {
        deletePaymentMethodSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_EMAIL_EDITABLE_TEMPLATE:
      return update(state, {
        getEmailEditableTemplate: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_EMAIL_EDITABLE_TEMPLATE:
      return update(state, {
        getEmailEditableTemplate: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_EMAIL_EDITABLE_TEMPLATE:
      return update(state, {
        getEmailEditableTemplate: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_EMAIL_EDITABLE_TEMPLATE:
      return update(state, {
        updateEmailEditableTemplate: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_EMAIL_EDITABLE_TEMPLATE:
      return update(state, {
        updateEmailEditableTemplate: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_EMAIL_EDITABLE_TEMPLATE:
      return update(state, {
        updateEmailEditableTemplate: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_EMAIL_SERVER_SETTINGS:
      return update(state, {
        getEmailServerSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_EMAIL_SERVER_SETTINGS:
      return update(state, {
        getEmailServerSettings: {
          isFetching: { $set: false },
        },
        emailSettings: { $set: action.data },
      });

    case A.ERROR_GET_EMAIL_SERVER_SETTINGS:
      return update(state, {
        getEmailServerSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_EMAIL_SERVER_SETTINGS:
      return update(state, {
        updateEmailServerSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_EMAIL_SERVER_SETTINGS:
      return update(state, {
        updateEmailServerSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_EMAIL_SERVER_SETTINGS:
      return update(state, {
        updateEmailServerSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_COUNTRIES_LIST:
      return update(state, {
        getCountriesList: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_COUNTRIES_LIST:
      return update(state, {
        getCountriesList: {
          isFetching: { $set: false },
        },
        countries: { $set: action.data },
      });

    case A.ERROR_GET_COUNTRIES_LIST:
      return update(state, {
        getCountriesList: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_COUNTREAGENTS:
      return update(state, {
        updateCounteragents: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_COUNTREAGENTS:
      return update(state, {
        updateCounteragents: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_COUNTREAGENTS:
      return update(state, {
        updateCounteragents: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_COUNTREAGENT:
      return update(state, {
        deleteounteragent: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_COUNTREAGENT:
      return update(state, {
        deleteounteragent: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_COUNTREAGENT:
      return update(state, {
        deleteounteragent: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PROMOCODES:
      return update(state, {
        getPromocodes: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PROMOCODES:
      return update(state, {
        getPromocodes: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_PROMOCODES:
      return update(state, {
        getPromocodes: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_SAVE_PROMOCODE:
      return update(state, {
        savePromocode: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_SAVE_PROMOCODE:
      return update(state, {
        savePromocode: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_SAVE_PROMOCODE:
      return update(state, {
        savePromocode: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_PROMOCODE:
      return update(state, {
        deletePromocode: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_PROMOCODE:
      return update(state, {
        deletePromocode: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_PROMOCODE:
      return update(state, {
        deletePromocode: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_FEED_SETTINGS:
      return update(state, {
        getFeedSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_FEED_SETTINGS:
      return update(state, {
        getFeedSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_FEED_SETTINGS:
      return update(state, {
        getFeedSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_FEED_SETTINGS:
      return update(state, {
        deleteFeedSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_FEED_SETTINGS:
      return update(state, {
        deleteFeedSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_FEED_SETTINGS:
      return update(state, {
        deleteFeedSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_FEED_SETTINGS:
      return update(state, {
        updateFeedSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_FEED_SETTINGS:
      return update(state, {
        updateFeedSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_FEED_SETTINGS:
      return update(state, {
        updateFeedSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_REFRESH_FEED:
      return update(state, {
        refreshFeed: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_REFRESH_FEED:
      return update(state, {
        refreshFeed: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_REFRESH_FEED:
      return update(state, {
        refreshFeed: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PRICE_SETTINGS:
      return update(state, {
        getPriceSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PRICE_SETTINGS:
      return update(state, {
        getPriceSettings: {
          isFetching: { $set: false },
        },
        priceSettings: { $set: action.data },
      });

    case A.ERROR_GET_PRICE_SETTINGS:
      return update(state, {
        getPriceSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PRICE_SETTINGS:
      return update(state, {
        updatePriceSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PRICE_SETTINGS:
      return update(state, {
        updatePriceSettings: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PRICE_SETTINGS:
      return update(state, {
        updatePriceSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_USERS:
      return update(state, {
        getUsers: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_USERS:
      return update(state, {
        getUsers: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_USERS:
      return update(state, {
        getUsers: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_USER:
      return update(state, {
        updateUser: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_USER:
      return update(state, {
        updateUser: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_USER:
      return update(state, {
        updateUser: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_USER:
      return update(state, {
        deleteUser: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_USER:
      return update(state, {
        deleteUser: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_USER:
      return update(state, {
        deleteUser: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_USER_ROLES:
      return update(state, {
        getUserRoles: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_USER_ROLES:
      return update(state, {
        getUserRoles: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_USER_ROLES:
      return update(state, {
        getUserRoles: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_USER_ROLE:
      return update(state, {
        updateUserRole: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_USER_ROLE:
      return update(state, {
        updateUserRole: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_USER_ROLE:
      return update(state, {
        updateUserRole: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_USER_ROLE:
      return update(state, {
        deleteUserRole: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_USER_ROLE:
      return update(state, {
        deleteUserRole: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_USER_ROLE:
      return update(state, {
        deleteUserRole: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PAYMENT_SETTINGS:
      return update(state, {
        getPaymentSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PAYMENT_SETTINGS:
      return update(state, {
        getPaymentSettings: {
          isFetching: { $set: false },
        },
        paymentSettings: { $set: action.data },
      });

    case A.ERROR_GET_PAYMENT_SETTINGS:
      return update(state, {
        getPaymentSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_NOTIFICATIONS:
      return update(state, {
        getNotifications: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_NOTIFICATIONS:
      return update(state, {
        getNotifications: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_NOTIFICATIONS:
      return update(state, {
        getNotifications: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_NOTIFICATION_TYPES:
      return update(state, {
        getNotificationTypes: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_NOTIFICATION_TYPES:
      return update(state, {
        getNotificationTypes: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_NOTIFICATION_TYPES:
      return update(state, {
        getNotificationTypes: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_NOTIFICATION:
      return update(state, {
        updateNotification: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_NOTIFICATION:
      return update(state, {
        updateNotification: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_NOTIFICATION:
      return update(state, {
        updateNotification: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_NOTIFICATION:
      return update(state, {
        deleteNotification: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_NOTIFICATION:
      return update(state, {
        deleteNotification: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_NOTIFICATION:
      return update(state, {
        deleteNotification: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_AD_ATTACHMENTS:
      return update(state, {
        getAdAttachments: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_AD_ATTACHMENTS:
      return update(state, {
        getAdAttachments: {
          isFetching: { $set: false },
        },
        adAttachments: { $set: action.data },
      });

    case A.ERROR_GET_AD_ATTACHMENTS:
      return update(state, {
        getAdAttachments: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_AD_ATTACHMENTS:
      return update(state, {
        deleteAdAttachments: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_AD_ATTACHMENTS:
      return update(state, {
        deleteAdAttachments: {
          isFetching: { $set: false },
          error: { $set: null },
        },
      });

    case A.ERROR_DELETE_AD_ATTACHMENTS:
      return update(state, {
        deleteAdAttachments: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PROVIDERS:
      return update(state, {
        getProviders: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PROVIDERS:
      return update(state, {
        getProviders: {
          isFetching: { $set: false },
        },
        providers: { $set: action.data },
      });

    case A.ERROR_GET_PROVIDERS:
      return update(state, {
        getProviders: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });
    case A.REQUEST_GET_ESHOPS_INFO:
      return update(state, {
        getEshopsInfo: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ESHOPS_INFO:
      return update(state, {
        getEshopsInfo: {
          isFetching: { $set: false },
          error: { $set: null },
        },
        eShops: { $set: action.data },
      });

    case A.ERROR_GET_ESHOPS_INFO:
      return update(state, {
        getEshopsInfo: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default settings;
